import { useTenant } from "hooks/settings";
import { useLocalStorageState } from "hooks/useLocalStorageState";

export const useCraneImpersonation = () => {
  const tenantName = useTenant();
  const [craneToImpersonate, setCraneToImpersonate] = useLocalStorageState<
    string | null
  >(`craneToImpersonate-${tenantName}`, null);
  return {
    craneToImpersonate,
    setCraneToImpersonate: (userUid: string | null) => {
      setCraneToImpersonate(userUid);
      window.location.reload();
    },
  };
};
